import { extractMessagesFromEvent, heartbeatMessageValue } from '@timeflies/socket-messages';
var createEndpoint = function (protocol, url) {
    var startIndex = url.indexOf('://');
    if (startIndex !== -1) {
        url = url.substr(startIndex + 3);
    }
    var secure = window.origin.startsWith('https')
        ? 's'
        : '';
    return "" + protocol + secure + "://" + url;
};
var createAuthenticatedEndpoint = function (token, serverUrl) {
    var baseEndpoint = createEndpoint('ws', serverUrl);
    var url = new URL(baseEndpoint);
    url.searchParams.set('token', token);
    return url.href;
};
export var getSocketHelperCreator = function (serverUrl) {
    return function createSocketHelper(token) {
        var endpoint = createAuthenticatedEndpoint(token, serverUrl);
        var socket = new WebSocket(endpoint);
        var heartbeatTimeout;
        var startHeartbeatTimeout = function () {
            clearTimeout(heartbeatTimeout);
            heartbeatTimeout = setTimeout(function () {
                socket.send(heartbeatMessageValue);
                startHeartbeatTimeout();
            }, 30000);
        };
        var addListener = function (type, listener) {
            socket.addEventListener(type, listener);
            return function () { return socket.removeEventListener(type, listener); };
        };
        startHeartbeatTimeout();
        addListener('close', function () { return clearTimeout(heartbeatTimeout); });
        return {
            url: socket.url,
            getReadyState: function () { return socket.readyState; },
            close: function () { return socket.close(); },
            send: function (messages) {
                socket.send(JSON.stringify(messages));
                startHeartbeatTimeout();
            },
            addOpenListener: function (listener) {
                return addListener('open', listener);
            },
            addCloseListener: function (listener) {
                return addListener('close', listener);
            },
            addMessageListener: function (listener) {
                var rootListener = function (event) {
                    var _a = extractMessagesFromEvent(event), messageList = _a.messageList, error = _a.error;
                    if (error) {
                        throw new Error(error);
                    }
                    listener(messageList);
                };
                return addListener('message', rootListener);
            }
        };
    };
};
